/* rev 2026-07-07b: cart:error throw + intercept error msg */
/**
 * ============================================
 * EC CORE — Earthing Connect 2.0
 * EventBus + Cart API + Form Intercept
 * ============================================
 */
(function () {
  'use strict';

  /* ── ROUTE HELPERS ── */
  var routes = (window.Theme && window.Theme.routes) || {};
  var cartAddUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var cartUrl = (routes.cart_url || '/cart') + '.js';
  var cartChangeUrl = (routes.cart_change_url || '/cart/change') + '.js';

  /* ── EVENT BUS ── */
  var EC = {
    emit: function (event, data) {
      document.dispatchEvent(new CustomEvent('ec:' + event, { detail: data || {} }));
    },
    _handlers: [],
    on: function (event, fn) {
      var wrapper = function (e) { fn(e.detail); };
      EC._handlers.push({ event: event, fn: fn, wrapper: wrapper });
      document.addEventListener('ec:' + event, wrapper);
    },
    off: function (event, fn) {
      for (var i = EC._handlers.length - 1; i >= 0; i--) {
        if (EC._handlers[i].event === event && EC._handlers[i].fn === fn) {
          document.removeEventListener('ec:' + event, EC._handlers[i].wrapper);
          EC._handlers.splice(i, 1);
        }
      }
    }
  };

  /* ── CART API ── */
  EC.cart = {
    add: function (variantId, quantity, properties) {
      quantity = quantity || 1;
      EC.emit('cart:adding', { variantId: variantId, quantity: quantity });
      /* 28.07 — properties opsiyonel (Fit satir-ozelligi icin); verilmezse eski davranis */
      var item = { id: parseInt(variantId, 10), quantity: quantity };
      if (properties && Object.keys(properties).length) item.properties = properties;
      return fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function (res) {
        if (!res.ok) {
          /* Shopify 422 gercek nedeni soyler (orn. "All 5 available in cart") — kullaniciya o gitsin */
          return res.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || ('Cart add failed: ' + res.status));
          }, function () {
            throw new Error('Cart add failed: ' + res.status);
          });
        }
        return res.json();
      })
      .then(function (data) {
        EC.emit('cart:added', data);
        EC.cart.refresh();
        return data;
      })
      .catch(function (err) {
        EC.emit('cart:error', { message: err.message });
        console.error('[EC Cart]', err);
        throw err; /* hatayi yutma — caller "Added!" gostermesin */
      });
    },

    refresh: function () {
      return fetch(cartUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          EC.emit('cart:updated', cart);
          EC.cart._updateCounts(cart.item_count);
          return cart;
        });
    },

    change: function (key, quantity) {
      return fetch(cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (res) {
        /* 422 (stok siniri vb) JSON'u sepet DEGIL hata objesidir — rozet/state'i bozma, kullaniciya soyle */
        if (!res.ok) {
          return res.json().then(function (err) {
            EC.emit('cart:change-error', { status: res.status, message: (err && (err.description || err.message)) || 'Could not update the cart.' });
            throw new Error('cart change ' + res.status);
          });
        }
        return res.json().then(function (cart) {
          EC.emit('cart:updated', cart);
          EC.cart._updateCounts(cart.item_count);
          return cart;
        });
      });
    },

    remove: function (key) {
      return EC.cart.change(key, 0);
    },

    _updateCounts: function (count) {
      document.querySelectorAll('.ec-cart-count, [data-ec-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }
  };

  /* ── FOCUS TRAP — a11y (drawer / modal) ── */
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var focusTrap = { container: null, handler: null, returnEl: null };

  EC.trapFocus = function (container) {
    if (!container || focusTrap.container === container) return;
    if (focusTrap.handler) document.removeEventListener('keydown', focusTrap.handler);
    focusTrap.container = container;
    focusTrap.returnEl = document.activeElement;
    focusTrap.handler = function (e) {
      if (e.key !== 'Tab') return;
      var nodes = container.querySelectorAll(FOCUSABLE_SELECTOR);
      var focusable = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetParent !== null) focusable.push(nodes[i]);
      }
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      if (!container.contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', focusTrap.handler);
  };

  EC.releaseFocus = function () {
    if (!focusTrap.container) return;
    if (focusTrap.handler) document.removeEventListener('keydown', focusTrap.handler);
    var returnEl = focusTrap.returnEl;
    focusTrap.container = null;
    focusTrap.handler = null;
    focusTrap.returnEl = null;
    if (returnEl && typeof returnEl.focus === 'function') returnEl.focus();
  };

  /* ── BACKWARD COMPAT ── */
  window.ecAddItem = function (v, q) { EC.cart.add(v, q).catch(function () {}); };
  window.gbAddItem = function (v, q) { EC.cart.add(v, q).catch(function () {}); };

  /* ── GLOBAL ── */
  window.EC = EC;

  /* ═══════════════════════════════════════════════
     FORM INTERCEPT — Tüm Shopify product form'larını yakala
     {% form 'product' %} POST /cart/add → EC.cart.add() → Side Cart aç
     ═══════════════════════════════════════════════ */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    // Sadece product form'larını yakala
    // Shopify form action: /cart/add veya /XX/cart/add (locale prefix)
    if (!form || !form.action) return;
    var isCartAdd = /\/cart\/add/.test(form.action);
    if (!isCartAdd) return;

    // Dynamic Checkout (Buy Now) butonlarını ATLA — onlar direkt checkout'a gitmeli
    var submitter = e.submitter;
    if (submitter) {
      var isDynamic = submitter.closest('.shopify-payment-button') ||
                      submitter.classList.contains('shopify-payment-button__button');
      if (isDynamic) return; // Buy Now → normal checkout flow
    }

    // Normal "Add to Cart" → Intercept
    e.preventDefault();

    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');

    if (!variantInput) return;

    var variantId = variantInput.value;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    /* 28.07 — form elle payload'a cevrildigi icin properties[...] inputlari KAYBOLUYORDU
       (Fit satir-ozelligi bu yuzden tasinmiyordu). Topla ve EC.cart.add'e gecir. */
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (m && el.value) props[m[1]] = el.value;
    });

    // Submit butonunu loading state'e al
    var submitBtn = form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var originalText = '';
    if (submitBtn) {
      originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:ec-spin .6s linear infinite"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="8"/></svg> ' + ((window.ECStrings && ECStrings.adding) || 'Adding…') + '</span>';
    }

    EC.cart.add(variantId, quantity, props)
      .then(function () {
        if (submitBtn) {
          submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:6px"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> ' + ((window.ECStrings && ECStrings.added) || 'Added!') + '</span>';
          setTimeout(function () {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }
      })
      .catch(function (err) {
        if (submitBtn) {
          /* 31.07 — kisa 422 aciklamasi (orn. 'Cannot find variant') musteriye aynen gider;
             durum-kodlu/JSON'suz hatalar nazik maskeye duser. (Gecici teshis geri alindi:
             telefondaki 'Couldn't add' vakasi bayat onbellekti, temizlenince gecti.) */
          var reason = (err && err.message && err.message.length <= 80 && err.message.indexOf('failed:') === -1) ? err.message : ((window.ECStrings && ECStrings.addError) || "Couldn't add — try again");
          submitBtn.innerHTML = reason;
          setTimeout(function () {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2600);
        }
      });
  });

})();
